import { render } from "./PageLoading.vue?vue&type=template&id=1fa648b7&scoped=true"
const script = {}

import "./PageLoading.vue?vue&type=style&index=0&id=1fa648b7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa648b7"]])

export default __exports__